// src/pages/LearningPathDetails.jsx
import React, { useEffect, useState } from "react";
import { Box, Heading, Text, Button } from "grommet";
import { CourseList } from "../../components/LearningPaths/CourseList";
import { useParams, useNavigate } from "react-router-dom";
import { StickyFooter } from "../../components/Footers/GlobalFooter";
import { HeaderNavigation } from "../../components/Headers/PursuitHeader";
import { LinkPrevious } from "grommet-icons";
import API_URL from "../../config/config";
import axios from "axios";

const LearningPathDetails = () => {
    const { learningpath_id, course_id } = useParams();
    const navigate = useNavigate();

    const [courses, setCourses] = useState([]);
    const [learningPathName, setLearningPathName] = useState("");
    const [selectedCourse, setSelectedCourse] = useState(course_id || null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(
                    `${API_URL}/dashboard/courses/${learningpath_id}`
                );
                setCourses(response.data.courses);
                setLearningPathName(response.data.learningPathName);
            } catch (error) {
                console.error("Error loading learning path:", error);
            }
        };
        fetchData();
    }, [learningpath_id]);

    const handleBack = () => navigate(-1);

    return (
        <Box fill="vertical" justify="between">
            <Box flex="grow">
                <HeaderNavigation />

                <Box fill="vertical" justify="between" pad="medium">
                    <Button
                        icon={<LinkPrevious size="large" color="brand" />}
                        onClick={handleBack}
                        plain
                    />

                    <Heading level={1}>{learningPathName}</Heading>
                    <Text size="medium" color="dark-3" margin={{ bottom: "medium" }}>
                        We recommend these courses to complete the learning path:
                    </Text>

                    <Box border={{ color: "brand", size: "xsmall" }} margin={{ bottom: "medium" }} />

                    <CourseList
                        courses={courses}
                        selectedCourse={selectedCourse}
                    />
                </Box>
            </Box>

            <StickyFooter />
        </Box>
    );
};

export default LearningPathDetails;
